<mulo-centered-block-layout class="padding-sm" width="auto">
  @if (isLoading) {
    <mulo-loading-slate>
      <mulo-spinner [diameter]="60"></mulo-spinner>
    </mulo-loading-slate>
  }
  @for (mention of mentions | paginate : paginationConfig; track trackByIndex(i, mention); let i = $index) {
    <exl-citation-brief
      (actionClick)="onActionClick($event, mention, i)"
            [hidden]="
                !profileService.isPublicPage &&
                (!mention.visibleInPortal || !mention.visibleInProfiles || !mention.displayInPublicProfile)
            "
      [menuActions]="getMenuAction(mention)"
      [titleClickable]="mention.links?.length > 0"
      [titleUrl]="mention.links[0]?.linkURL"
      [type]="mention.type"
      title="&quot;{{ mention.title }}&quot;"
      [titleHeaderLevel]="3"
      >
      <p class="mention-byline">{{ getByline(mention) }}</p>
      <p class="mention-date">{{ mention.dateMedia }}</p>
      @if (mention.links?.[0]?.linkRights; as linkRightsKey) {
        <p
          class="mention-rights"
          [translate]="'esploro.accessRights.links.' + linkRightsKey"
        ></p>
      }
      @if (!mention.displayInPublicProfile) {
        <ng-container slot="additional-status-tags">
          <mulo-status-tag [description]="'research.profile.hide.status.hidden.tooltip' | translate">
            {{ 'research.profile.hide.status.hidden' | translate }}
          </mulo-status-tag>
        </ng-container>
      }
      @if (!profileService.isPublicPage) {
        <div class="visibility">
          @if (!mention.visibleInPortal) {
            <mat-icon
              [matTooltip]="'research.visibility.noPortal' | translate"
              class="margin-right-xs"
              muloSvgViewbox
              svgIcon="public-off"
            ></mat-icon>
          }
          @if (!mention.visibleInProfiles) {
            <mat-icon
              [matTooltip]="'research.visibility.noProfiles' | translate"
              class="margin-right-xs"
              muloSvgViewbox
              svgIcon="person-off"
            ></mat-icon>
          }
          @if (!mention.visibleInPortal && !mention.visibleInProfiles) {
            <span>{{
              'research.visibility.noPnP' | translate
            }}</span>
          }
          @if (!mention.visibleInPortal && mention.visibleInProfiles) {
            <span>{{
              'research.visibility.noPortal' | translate
            }}</span>
          }
          @if (mention.visibleInPortal && !mention.visibleInProfiles) {
            <span>{{
              'research.visibility.noProfiles' | translate
            }}</span>
          }
        </div>
      }
    </exl-citation-brief>
  }
  @if (pagesCount > 1) {
    <div class="pagination-wrap">
      <mulo-floating-toolbar class="margin-top-md">
        <div slot="toolbar-middle">
          <pagination-template
            #p="paginationApi"
            (pageChange)="pageChange($event)"
            [id]="paginationConfig.id"
            [maxSize]="7"
            >
            <mulo-paging
              [data]="p"
              [nextLabel]="'research.search.results.next' | translate"
              [previousLabel]="'research.search.results.previous' | translate"
              [screenReaderJumpLabel]="'research.aria.results.page.jump.button' | translate"
              id="pagination"
            ></mulo-paging>
          </pagination-template>
        </div>
      </mulo-floating-toolbar>
    </div>
  }
</mulo-centered-block-layout>
